enum BalanceButtonValueEnum {
  HALF,
  MAX
}

export default BalanceButtonValueEnum
